import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import useEvaluationActions from "../../../api/hooks/rater/evaluation";
import { authState } from "../../../recoil/auth";
import {
  raterQuestionStartState,
  raterRoomListState,
} from "../../../recoil/rater/evaluation";
import { useMutation, useQuery } from "@tanstack/react-query";

const ListToEvaluation = () => {
  const navigate = useNavigate();
  const [raterRoomList, setRaterRoomList] = useRecoilState(raterRoomListState);
  const [isRaterQuestionStart, setRaterQuestionStart] = useRecoilState(
    raterQuestionStartState
  );
  const auth = useRecoilValue(authState);
  const evaluationActions = useEvaluationActions();

  useEffect(() => {
    getRaterRoomList();
  }, []);

  const getRaterRoomList = () => {
    mutation.mutate({ user_sn: auth.user.sn });
  };

  const mutation = useMutation(evaluationActions.getRaterRoomList, {
    onSuccess: (context) => {
      if (context.status === 200) {
        setRaterRoomList(context.data || []);
      }
    },
    onError: () => {
      alert("결과 불러오기 실패.");
    },
  });

  return (
    <div className="admin_content">
      <div className="content-title">
        <p className="exam">시험실</p>
      </div>
      <div className="content-cont">
        <div className="container">
          <div className="tab-title">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active">시험실 목록</button>
              </li>
            </ul>
          </div>
          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active">
              <div className="tab-title">
                <p style={{ marginBottom: "1.125rem" }}>평가자</p>
              </div>
              <div className="overflow-scroll height-300">
                <table className="rater-table">
                  <tbody>
                    <tr>
                      {/* <th>No.</th> */}
                      <th>시험실 제목</th>
                      <th>시험실 상태</th>
                      <th>평가수</th>
                      <th>평가진행</th>
                      <th>평가</th>
                    </tr>
                    {raterRoomList?.map((examRoom, key) => {
                      return (
                        <tr key={examRoom.room_sn}>
                          {/* <td>1</td> */}
                          <td className="text-align-left">
                            <button
                              className="test-title-link"
                              onClick={() => {
                                if (examRoom.done === examRoom.total) {
                                  setRaterQuestionStart(false);
                                } else {
                                  setRaterQuestionStart(true);
                                }
                                navigate(
                                  `/rater/examroom/question/` + examRoom.room_sn
                                );
                              }}
                            >
                              {examRoom.group_title}
                            </button>
                          </td>
                          <td>
                            {examRoom.done === examRoom.total
                              ? "종료"
                              : "진행중"}
                          </td>
                          <td>{examRoom.total}</td>
                          <td>
                            <div className="slidecontainer">
                              <input
                                disabled
                                type="range"
                                min={0}
                                max={examRoom.total}
                                className="slider"
                                id="myRange"
                                defaultValue={examRoom.done}
                              />
                              <span className="range-text">
                                <span>
                                  ({examRoom.done}/{examRoom.total})
                                </span>
                              </span>
                            </div>
                          </td>
                          <td>
                            <button
                              className="btn-custom b-btn"
                              style={{ margin: "12px 0" }}
                              onClick={() => {
                                if (examRoom.done === examRoom.combo_total) {
                                  alert("평가를 이미 완료했습니다.");
                                } else {
                                  navigate(
                                    `/rater/examroom/${examRoom.room_sn}`
                                  );
                                }
                              }}
                            >
                              평가하기
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListToEvaluation;
